import { Box, Button, Text } from "@chakra-ui/react";
import React from "react";

const CreateFolderModal = ({isOpen, onClose, isOpenAction, handleCreateFolder}) => {
    const [newFolderName, setNewFolderName] = React.useState("");

    if (!isOpen) return null;
    if (isOpenAction !== "create-folder") return null;

    const triggerCreateFolder = () => {
        handleCreateFolder({newFolderName});
        setNewFolderName("");
    }

    return (
        <Box
            position="fixed" 
            top="0" 
            left="0" 
            width="100vw" 
            height="100vh" 
            bg="rgba(0, 0, 0, 0.5)" 
            display="flex" 
            alignItems="center" 
            justifyContent="center"
        >
            <Box 
                bg="white" 
                p="24px" 
                borderRadius="md" 
                boxShadow="lg" 
                width="400px"
            >
                <Text fontSize="lg" fontWeight="bold" mb="16px">Create New Folder</Text>
                <Box mb="16px">
                    <input 
                        type="text" 
                        value={newFolderName} 
                        onChange={(e) => setNewFolderName(e.target.value)} 
                        placeholder="Enter folder name" 
                        style={{
                            width: "100%", 
                            padding: "8px", 
                            border: "1px solid #ccc", 
                            borderRadius: "4px"
                        }}
                    />
                </Box>
                <Box display="flex" justifyContent="flex-end" gap="8px">
                    <Button onClick={onClose}>Cancel</Button>
                    <Button
                        color={"white"}
                        bgColor={"#2584FD"} 
                        _hover={{
                            backgroundColor: "#2584FD",
                        }}
                        onClick={triggerCreateFolder}
                    >Create</Button>
                </Box>
            </Box>
        </Box>
    )
}

export default CreateFolderModal;